import React from 'react'
import { Placeholder } from '@s4l/ds'

import styles from './styles.module.css'

function RoomPreviewPlaceholder() {
  return (
    <div className={styles.roomHeader} data-testid="room-header">
      <div className={styles.roomImageContainer}>
        <div className={styles.roomImage}>
          <Placeholder width="100%" height="175px" rounded />
        </div>
      </div>
      <div className={styles.roomHeaderInfoContainer}>
        <Placeholder.Text lines={1} lineHeight="24px" width="100%" />
        <div className={styles.roomHeaderGuestAndFacilitiesContainer}>
          <span className={styles.roomHeaderGuestContainer}>
            <Placeholder width="14px" height="14px" rounded />
            <Placeholder width="120px" height="20px" rounded />
          </span>
        </div>
        <div>
          <Placeholder width="100px" height="20px" rounded />
        </div>
      </div>
      <Placeholder.Animation />
    </div>
  )
}

RoomPreviewPlaceholder.displayName = 'RoomPreviewPlaceholder'

export default RoomPreviewPlaceholder
